const React = require('react');

const { useState, useEffect, useCallback } = React;
const { RadioList } = require('@andes/radio-list');
const { Button } = require('@andes/button');
const { VisuallyHidden } = require('@andes/common');
const { Card } = require('@andes/card');
const classnames = require('classnames');
const addressProps = require('../props/addresses');
const ListItemSecondary = require('./ListItemSecondary');
const { numberOfAddressesToShow } = require('../../../constants/addresses-list');
const { track } = require('../../../helpers');

const { RadioListItem } = RadioList;

const namespace = 'addresses-list';

const ListLocations = ({
  title,
  addresses,
  deviceType,
  isFlow,
  isStateCity,
  isNative,
  translations,
  appId,
  editAddressesURL,
  selectionChanged,
  selectedAddress,
  setIsScroll,
  shouldRenderExternalLinks,
  actions,
}) => {
  const [showMore, setShowMore] = useState(false);
  const filteredAddresses = showMore ? addresses : addresses.slice(0, numberOfAddressesToShow);
  const announceMoreComments = showMore ? translations.announceMoreAddresses : translations.announceLessAddresses;

  const classesActions = classnames(`${namespace}__actions`, {
    [`${namespace}__actions--empty`]: addresses.length <= numberOfAddressesToShow && !shouldRenderExternalLinks,
  });
  useEffect(() => {
    if (window.innerHeight + window.scrollY < document.body.offsetHeight) {
      setIsScroll(true);
    } else {
      setIsScroll(false);
    }
    if (isFlow) {
      const modalContent = document.querySelector('.andes-modal.layout');
      const contentHeight = Math.min(modalContent.scrollHeight, modalContent.offsetHeight);
      const width = deviceType === 'desktop' ? '672px' : null;
      const modalProps = {
        type: 'nav:cp:updateSize',
        height: `${contentHeight}px`,
        width,
      };

      window.parent.postMessage(modalProps, '*');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMore]);

  const onEditAddressesHandler = () => {
    track('hub', 'edit_address', { app: appId });
  };

  const onChangeAddressHandler = useCallback(
    (addressId) => {
      track('hub', 'change_address', {
        address_id: addressId,
        app: appId,
      });
    },
    [appId],
  );

  const isEditAddressButtonVisible = !actions || actions?.edit_address?.state !== 'HIDDEN';
  const shouldDisplayEditAddressesButton = shouldRenderExternalLinks && isEditAddressButtonVisible;

  return (
    <>
      {isStateCity && <input type="hidden" name="state_city" value="yes" />}
      {title && <h2 className="header-subtitle header-subtitle">{title}</h2>}

      <Card>
        <RadioList
          value={String(selectedAddress)}
          onChange={(_, item) => {
            selectionChanged(Number(item));
            onChangeAddressHandler(Number(item));
          }}
          className={namespace}
          srLabel={translations.addresses}
          id={`${namespace}_list`}
          name="address_id"
        >
          {filteredAddresses.map((address) => (
            <RadioListItem
              className={`${namespace}__item`}
              title={address.title}
              description={<ListItemSecondary {...address} />}
              disabled={!address.enabled}
              key={address.address_id}
              id={`address_${address.address_id}`}
              value={String(address.address_id)}
              data-testid={`address_${address.address_id}`}
            >
              {address.state && (
                <input type="hidden" name={`address_state_${address.address_id}`} value={address.state.id} />
              )}
              {address.city && address.city.id && (
                <input type="hidden" name={`address_city_${address.address_id}`} value={address.city.id} />
              )}
              {address.zipcode && (
                <input type="hidden" name={`address_zipcode_${address.address_id}`} value={address.zipcode} />
              )}
            </RadioListItem>
          ))}
        </RadioList>
        <div className={classesActions}>
          {addresses.length > numberOfAddressesToShow && (
            <>
              <VisuallyHidden role="alert" aria-live={isNative ? 'polite' : 'assertive'}>
                {announceMoreComments}
              </VisuallyHidden>
              <Button
                className={`${namespace}__action ${namespace}__action--show-more`}
                data-testid="show-more-addresses"
                hierarchy="transparent"
                size="medium"
                onClick={() => setShowMore(!showMore)}
              >
                {showMore ? translations.showLess : translations.showMore}
              </Button>
            </>
          )}
          {addresses.length > numberOfAddressesToShow
            ? shouldDisplayEditAddressesButton && <span className={`${namespace}__button-separator`} />
            : null}
          {shouldDisplayEditAddressesButton && (
            <Button
              className={`${namespace}__action`}
              hierarchy="transparent"
              target="_parent"
              size="medium"
              href={editAddressesURL}
              onClick={onEditAddressesHandler}
            >
              {translations.editAddresses}
            </Button>
          )}
        </div>
      </Card>
    </>
  );
};

ListLocations.propTypes = addressProps.propTypes;

ListLocations.defaultProps = addressProps.defaultProps;

module.exports = ListLocations;
